module.exports = __webpack_public_path__ + "img/F976.1d177a8a.jpg";